//#region react
import React from "react";
//#endregion

//#region components
import AcreosSelect from "../../../Components/AcreosSelect/AcreosSelect.component";
import MultiSelect from "../../../Components/MultiSelect/MultiSelect.component";
import MachineCell from "./Cells/MachineCell";
import TrainingCell from "./Cells/TrainingCell";
//#endregion

//#region constants
import { ICON_ADD_CIRCLE, ICON_DELETE } from "../../../Constants/IconConstants";
import { TRANSLATIONS } from "../../../Constants/Translations";
//#endregion

//#region helpers
import { getTranslations } from "../../../Helper/TranslationController";
//#endregion

const DependentSelectRow = ({
  rowIndex,
  translations,
  machineOptions,
  getTrainingOptions,
  rowData,
  onMachineSelect,
  onTrainingSelect,
  onAddRow,
  onDeleteRow,
  showDeleteButton = true,
}) => {
  const trainingOptions = getTrainingOptions(rowData.machineId);
  const shouldShowTrainingSelect = !!rowData.machineId;

  return (
    <article className="create-formation-form_select">
      <AcreosSelect
        setNewValue={(value) => onMachineSelect(rowIndex, value)}
        options={machineOptions}
        value={rowData.machineId}
        defaultText={getTranslations(TRANSLATIONS.GSTA_SELECT_MACHINE, translations)}
        addClassCustom={"acreos-select-column custom-field_select custom-field--width"}
        OptionComponent={(props) => (
          <MachineCell
            {...props}
            translations={translations}
          />
        )}
        isValid
      />

      <MultiSelect
        setNewValue={(value) => onTrainingSelect(rowIndex, value)}
        options={trainingOptions}
        value={rowData.trainingId}
        defaultText={`0 ${getTranslations(TRANSLATIONS.SELECTED_TRAININGS, translations)}`}
        addClassCustom={`acreos-select-column custom-field_select custom-field--width ${
          shouldShowTrainingSelect ? "" : "invisible"
        }`}
        OptionComponent={(props) => (
          <TrainingCell
            {...props}
            translations={translations}
          />
        )}
        isValid
      />

      <button
        type="button"
        className={`gsta-table-action-button ${showDeleteButton ? "" : "invisible"}`}
        onClick={() => onDeleteRow(rowIndex)}
      >
        <i className={ICON_DELETE} />
      </button>

      <button
        type="button"
        className="gsta-table-action-button"
        onClick={() => onAddRow(rowIndex)}
      >
        <i className={ICON_ADD_CIRCLE} />
      </button>
    </article>
  );
};

export default DependentSelectRow;
